interface ScrollExpandProps {
  startWidth?: number
}

export default function scrollExpand(
  el: HTMLElement,
  props: ScrollExpandProps
): void {
  const reduceMotion = window.matchMedia(
    "(prefers-reduced-motion: reduce)"
  ).matches

  const startWidth = props.startWidth ?? 1000

  el.style.transition = "max-width 0.15s ease-out"

  if (reduceMotion) {
    el.style.maxWidth = "100%"
    return
  }

  const update = () => {
    // Full width when the element's bottom edge reaches the viewport bottom
    const elBottom = el.offsetTop + el.offsetHeight
    const scrollEnd = elBottom - window.innerHeight
    const progress = Math.min(
      1,
      Math.max(0, window.scrollY / Math.max(1, scrollEnd))
    )

    const width = startWidth + (window.innerWidth - startWidth) * progress
    el.style.maxWidth = `${Math.min(width, window.innerWidth)}px`
  }

  window.addEventListener("scroll", update, { passive: true })
  window.addEventListener("resize", update, { passive: true })
  update()
}
